import { Collection } from 'modules/core/lib/mobx-rest'

import { ApprovalStatus } from 'modules/contracts/lib/enums'
import Compensation from 'modules/contracts/store/models/Compensation'

export class Compensations extends Collection<Compensation> {
  get indexes() {
    return ['contract_version_id']
  }

  async batchFetchByIds(ids: number[], sliceSize: number) {
    ids = Array.from(new Set(ids)) // removes duplicate ids

    const batches = []
    this.reset([]) // clear the existing collection
    for (let i = 0; i < ids.length; i += sliceSize) {
      const slicedIds: number[] = ids.slice(i, i + sliceSize)

      batches.push(
        this.fetch({
          data: {
            ids: slicedIds,
          },
          remove: false,
        })
      )
    }

    await Promise.all(batches)
  }

  async fetchWithContractApprovalStatusByContractIds(
    contractVersionIds: number[] = [],
    contractApprovalStatus: ApprovalStatus[] = []
  ): Promise<void> {
    return super.fetch({
      data: {
        contract_version_ids: contractVersionIds,
        contract_approval_status: contractApprovalStatus,
      },
    })
  }

  model() {
    return Compensation
  }
}

export default new Compensations()
